import styled, { css } from 'styled-components'
import { themeStyles, themeMedia } from '../../../styles/theme'

export const StyledPaymentSectionTitle = styled.h2`
  font-weight: 700;
  font-size: 1.5rem;
  margin: 0;

  ${themeMedia.desktop`
    justify-content: flex-start;
    font-size: 1.37rem;
  `};
`

export const StyledDepositAmountWrapper = styled.div`
  display: flex;
  flex-direction: column;

  margin-top: 30px;
  height: ${({ showQR }) => (showQR ? 'auto' : '100%')};

  ${({ $addBottomMargin }) =>
    $addBottomMargin &&
    css`
      margin-bottom: 1rem;
    `}
`

export const StyledDepositAmountTitle = styled.h3`
  margin: 8px 0 0;
  font-weight: 400;
  font-size: 17px;
  color: #5A5A5A;
`

export const StyledDepositAmount = styled.div`  
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  margin-bottom: 1.5rem;

  ${themeMedia.desktop`
    justify-content: flex-start;
    flex-direction: column;
    margin-bottom: 2.5rem;
  `};
`

export const StyledDepositAmountValue = styled.span`
  font-weight: 700;
  font-size: 3.125rem;
  line-height: 1.3;
  color: #000000;
`

export const StyledDepositAmountChange = styled.button`
  display: flex;
  align-items: center;
  background: transparent;
  border: none;
  cursor: pointer;

  img {
    margin-right: 5px;
  }

  span {
    font-weight: 400;
    font-size: 15px;
    color: #3C3C3C;
  }
`

export const StyledAccountDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 28px;

  padding: 28px 0;
  border-top: 2px solid #EEEEEE;
  border-bottom: 2px solid #EEEEEE;
  margin-bottom: 12px;

  ${themeMedia.desktop`
    padding: 20px 0;
  `};
`

export const StyledAccountDetailsSection = styled.div`
  display: flex;
  justify-content: space-between;

  span {
    font-weight: 400;
    font-size: 17px;
    color: #5A5A5A;
  }

  span:nth-child(1) {
    font-weight: 600;
  }
`

export const StyledQRCodeImageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 1.2rem;
  padding-bottom: 3rem;

  h3 {
    font-weight: 700;
    font-size: 20px;
    margin: 0 0 10px;
  }

  ${themeMedia.desktop`
    margin: auto 0 20px;
    padding-bottom: 0;
  `};
`

export const StyledBanksAccountsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  span {
    font-weight: 400;
    font-size: 13px;
  }
`

export const StyledBanksAccountsItem = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;

  div {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
`

export const StyledBankName = styled.h3`
  font-weight: 600;
  font-size: 12px;
  color: #1E1E1E;
  margin: 0;
`

export const StyledBankType = styled.h4`
  font-weight: 400;
  font-size: 12px;
  color: #5A5A5A;
  margin: 0;
`

export const StyledCopyQRCodeText = styled.span`
  font-weight: 700;
  font-size: 20px;
  margin: 0 0 1rem;
  text-align: center;
  display: block;

  ${themeMedia.desktop`
    font-weight: 400;
    font-size: 17px;
  `};
`

export const StyledQRCodeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  margin-top: auto;
  padding-top: 1.2rem;
`

export const StyledCopyQRCodeContainer = styled.div`
  margin-bottom: ${({ $isInGame }) => ($isInGame ? '0' : '1rem')};
  ${({ $isInGame }) =>
    $isInGame &&
    `
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      padding: 19px 26px 26px;
      background: ${themeStyles.colors.white.main};
    `}
`
